// extracted by mini-css-extract-plugin
export default {"payments":"PaymentData_payments__iTh0O","payments_cards":"PaymentData_payments_cards__+zoXu"};